@if (isVisible()) {
  <span
    class="inline-flex items-center gap-1 rounded-full border border-gray-700 px-2 py-0.5 text-xs opacity-80"
    [title]="tooltip()"
    data-testid="ai-generated-label"
  >
    <i class="pi pi-sparkles text-xs"></i>
    <span>{{ provenance()?.label }}</span>
  </span>
}
